






























import { Vue, Component } from 'vue-property-decorator';
// import { Session } from '../../utils/Session';
import { routeHelper } from '../../utils/routeHelper';
import { getKiyaku } from '../../kiyaku_stu';
@Component({
  components: {},
})
export default class StudentTermOfUsePage extends Vue {
  goNextPage() {
    routeHelper(this, 'NewStudentPage');
  }
  get building() {
    return this.$route.query.building as string;
  }

  get kiyaku() {
    if (this.building === 'co01') {
      return 'https://docs.google.com/document/d/1vGhrl6ejQQmEZYHHMWLYK7mOIO5knpvSpvyaiRnPLAE/edit';
    } else {
      return getKiyaku(this.building);
    }
  }
}
